import React, { useEffect, useState } from 'react';
import { Button, Header, Table, Pagination, useFrontier, Toolbar } from 'react-frontier2';
import { CompleteRefundModal, ErrorHeader } from '../../components';
import { ListRefund } from '../../AdminClasses';
import { bindClick, fromUnix } from '@arema/components/Util';
import { Link } from 'react-router-dom';
import { useTitle } from '@arema/components/Hooks';
import { useUser } from '../../AdminHooks';
import { useTranslation } from 'react-i18next';
import { Money } from '@arema/components';
import API from '../../API';
import classNames from 'classnames';

const REFUND_COUNT = 15

enum ShownModal {
	VIEW_REFUND = 1,
	SELECT_REFUNDS = 2,
	COMPLETE_PENDING = 20,
	DOWNLOAD_STP = 21,
}

enum SelectType {
	CANCEL = 2,
	COMPLETE = 10,
	STP = 20,
}

interface RefundChanges {
	refund_id: number,
	data: { [x: string]: any },
}

var RefundList = ()=>{
	var { t } = useTranslation();
	var { setTitle } = useTitle();
	var [pendingRefunds, setPendingRefunds] = useState<ListRefund[]>(null);
	var [completedRefunds, setCompletedRefunds] = useState<ListRefund[]>(null);
	var [shownModal, setShownModal] = useState<ShownModal>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [selectType, setSelectType] = useState<SelectType>(null);
	var [page, setPage] = useState<number>(0);
	var [pageLoading, setPageLoading] = useState<boolean>(false);

	useEffect(()=>{
		setTitle('Reembolsos');
		if(completedRefunds === null){
			setLoadError(null);
			API.getRefunds(true, true, 0, REFUND_COUNT).then(res=>{
				if(res.error) return setLoadError(res.message);
				setPendingRefunds(res.data.pending);
				setCompletedRefunds(res.data.completed);
			}).catch(err=>{
				setLoadError('Hubo un error inesperado cargando los reembolsos (LCL-1)');
			})
		}
	}, []);

	if(loadError){
		return <ErrorHeader error={loadError} />
	}

	if(completedRefunds === null){
		return <Header loading text={t('common.loading')} />
	}

	var onPageChange = (new_page: number)=>{
		setPage(new_page);
		setPageLoading(true);
		API.getRefunds(false, true, new_page*REFUND_COUNT, REFUND_COUNT).then(res=>{
			if(res.error) return setLoadError(res.message);
			setCompletedRefunds(res.data.completed);
		}).catch(err=>{
			setLoadError('Hubo un error inesperado cargando los reembolsos (LCL-2)');
		}).finally(()=>{
			setPageLoading(false);
		})
	}

	var updateRefunds = (refunds: RefundChanges[])=>{
		var all_refunds = [...completedRefunds, ...pendingRefunds];
		for (var i of refunds){
			var ix = all_refunds.findIndex(a=>a.refund_id == i.refund_id);
			if(ix == -1) return;
			all_refunds[ix] = {
				...all_refunds[ix],
				...i.data
			};
		}
		setPendingRefunds(all_refunds.filter(a=>!a.cancelled && !a.completed));
		setCompletedRefunds(all_refunds.filter(a=>a.completed));
	}

	var selectRefunds = (select_type: SelectType, stp?: boolean)=>{
		return ()=>{
			setSelectType(select_type);
			setShownModal(ShownModal.SELECT_REFUNDS);
		}
	}

	// var shown_refund = viewingRefund ? [...pendingRefunds, ...completedRefunds].find(a=>a.refund_id == viewingRefund) : null;
	// var CompleteOptions = completeForm && selectType===SelectType.COMPLETE && ACCESS.complete && !completeForm?.stp && (
	// 	<div style={{ marginTop: 15 }}>
	// 		<Checkbox checked={completeForm.completed && !completeForm.stp} label={'Este reembolso ya se depositó'} onChange={onCompleteFormChange('completed')} disabled={completeForm.stp} style={{ marginBottom: 5 }} />
	// 	</div>
	// )

	return <div>
		<Header text='Reembolsos' />
		<Toolbar style={{ maxWidth: 500, margin: 'auto' }} stretch={false}>
			{/* <Toolbar.Item text='Filtrar evento' iconName='filter' /> */}
			<Toolbar.Dropdown text='Seleccionar' disabled={pendingRefunds.length===0} iconName='circle-check' items={[
				{ text: 'Completar', onClick: selectRefunds(SelectType.COMPLETE) },
				{ text: 'Descargar STP', onClick: selectRefunds(SelectType.STP, true) }
			]} />
		</Toolbar>
		{pendingRefunds.length==0 && completedRefunds.length==0 && (
			<Header text={'Sin reembolsos'} subtext={'El sistema no tiene reembolsos creados'} iconName='smile' style={{ marginTop: 30 }} />
		)}
		{pendingRefunds.length > 0 && (
			<Table selectable style={{ maxWidth: 600, margin: 'auto', marginTop: 15 }}>
				<Table.Head title='Pendientes' data={[['ID', 'Folio', 'Tipo', 'Fecha', 'Cantidad']]} />
				<Table.Body>
					{pendingRefunds.map(a=>(
						<Table.Row compact
							as={Link}
							to={`/refunds/${a.refund_id}`}
							collapsingIndexes={[0, 1, 2, 4, 5]}
							data={[
								a.refund_id, 
								a.order_id, 
								t(`refund_list.${a.direct_refund ? 'direct_refund': 'bank_transfer'}`),
								fromUnix(a.date_created).toFormat('dd/MMM/yy HH:mm'), 
								<Money value={a.total} />
							]}
						/>
					))}
				</Table.Body>
			</Table>
		)}
		{completedRefunds.length > 0 && (
			<Table selectable style={{ maxWidth: 700, margin: 'auto', marginTop: 15, }}>
				<Table.Head
					collapsingIndexes={[0, 1, 2, 4, 5]}
					title='Completados'
					data={[['ID', 'Folio', 'Tipo', 'Fecha', 'Cantidad', 'Estatus']]}
				/>
				<Table.Body>
					{pageLoading ? (
						<Table.Row key={'tcmplld'}>
							<Table.Cell colSpan={6} key={'tcmplldc'}>
								<Header loading text='Cargando reembolsos' style={{ margin: '50px 0' }} />
							</Table.Cell>
						</Table.Row>
					) : completedRefunds.map(a=>(
						<Table.Row collapsingIndexes={[0, 1, 2, 4, 5]} compact as={Link} to={`/refunds/${a.refund_id}`} key={`tblc-${a.refund_id}`} data={[
							a.refund_id, 
							a.order_id, 
							t(`refund_type.type_${a.refund_type}`), 
							fromUnix((a.date_completed || a.date_cancelled || a.date_created)).toFormat('dd/MMM/yy HH:mm'), 
							<Money value={a.total} />,
							<div className={classNames('fr label', {
								green: !a.cancelled,
								red: a.cancelled
							})}>
								{a.cancelled ? 'Rechazada' : 'Completada'}
							</div>
						]} />
					))}
				</Table.Body>
				{page>0 || pageLoading || completedRefunds.length==REFUND_COUNT ? (
					<Table.Footer>
						<Table.Cell row colSpan={10}>
							<div style={{ justifyContent: 'flex-end', display: 'flex', padding: 5 }}>
								<Pagination page={page} disabled={pageLoading} onPageChange={onPageChange} hasNext={completedRefunds.length>=REFUND_COUNT} />
							</div>
						</Table.Cell>
					</Table.Footer>
				) : null}
			</Table>
		)}
		<CompleteRefundModal
			refunds={selectType===SelectType.STP ? pendingRefunds.filter(a=>!a.direct_refund) : pendingRefunds}
			onCompleted={r=>updateRefunds(r.map(a=>({ refund_id: a, data: { completed: true } })))}
			completed={selectType===SelectType.COMPLETE}
			stp={selectType===SelectType.STP}
			onClose={bindClick(setShownModal)}
			open={shownModal===ShownModal.SELECT_REFUNDS && !!selectType}
		/>
	</div>
}

export default RefundList;